// const originURL = window.location.origin;
// console.log("originURL uat", originURL);

const UatConfig = {
  navURL: "https://wt06.bluecross.com.hk",

  //接口请求的前缀
  baseURL: "https://wt01.bluecross.com.hk/MedicalService/api",

  //付款的js
  paymentJs:
    "https://wt06.bluecross.com.hk/Scripts/payment-gateway-checkout.js?20240124104940578",

  //  antd Upload组件的上传接口地址
  actionTempUrl:
    "https://wt01.bluecross.com.hk/MedicalService/api/VHISLoveYourSelf/SaveF",

  // 文件打开tab预览的baseUrl
  preViewUrl: "https://wt01.bluecross.com.hk",

  superAgentURL: "https://wt01.bluecross.com.hk/SuperAgent",
};

export default UatConfig;
